/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, InputGroup, Button, Nav, NavItem, NavLink,
  TabContent, TabPane, Badge, Card, CardBody, Collapse,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import classnames from 'classnames';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';
import { QueryBuilder } from 'react-querybuilder';
import { post, put, get } from '../../helpers/api_helper';
import BaseGrid from '../Common/BaseGrid';

function FamilyForm(props) {
  const {
    entity,
    t,
    onSuccess,
  } = props;

  const [componentSelector, setComponentSelector] = useState(false);
  const [properties, setProperties] = useState([]);
  const [fields, setFields] = useState([]);
  const [activeScope, setActiveScope] = useState('any');
  const [openInstructionRule, setOpenInstructionRule] = useState(null);

  const scopeTabs = [
    {
      value: 'any',
      label: 'Any',
      description: 'This scope affects both sides of the family.',
      details: 'It helps decide which listings belong to the family, and it also helps decide which component stock can be used to build that family\'s available quantity.',
    },
    {
      value: 'listing',
      label: 'Listings Only',
      description: 'This scope controls family membership on the listing side.',
      details: 'If a listing matches this rule, that listing can be included in the family. Once a listing is part of the family, the family\'s derived quantity is what gets pushed onto that listing, and sales of that listing are what get linked back to the family when Fuse creates workorders. This scope does not change which component stock is counted.',
    },
    {
      value: 'component',
      label: 'Components Only',
      description: 'This scope controls the supply side only.',
      details: 'It decides which component items and stock are counted when calculating the family\'s derived quantity, but it does not decide which listings belong to the family or which sold listings create workorders for that family.',
    },
    {
      value: 'instruction',
      label: 'Instruction Only',
      description: 'This scope is for guidance only.',
      details: 'It does not affect listing membership, derived quantity, or workorder linking. It only shows instructions on relevant workorders.',
    },
  ];

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const ValidationSchema = Yup.object().shape({
    name: Yup
      .string()
      .required(props.t(t('Family Name is required'))),
    components: Yup.array().of(Yup.object().shape({
      item_id: Yup.number().nullable(),
      item_qty: Yup.number().required().min(1),
      instructions: Yup.string(),
      query: Yup.string().nullable(),
      description: Yup.string().nullable(),
      scope: Yup.string(),
    })),
  });

  const createFamily = async (data) => {
    try {
      const d = {
        ...data,
        components: data.components.map((x) => ({
          item_id: x.item_id || null,
          item_qty: x.item_qty,
          instructions: x.instructions,
          query: x.query,
          qty: x.qty,
          description: x.description,
          scope: x.scope,
        })),
      };

      const family = await post('/api/fuse/family', d);

      toastr.success(`${data.name} created!`, t('Success'));
      onSuccess(family);
    } catch (error) {
      toastr.error(error.message, t('Error while creating'));
    }
  };

  const editFamily = async (data) => {
    try {
      const d = {
        ...data,
        components: data.components.map((x) => ({
          item_id: x.item_id,
          item_qty: x.item_qty,
          instructions: x.instructions,
          query: x.query,
          qty: x.qty,
          description: x.description,
          scope: x.scope,
        })),
      };

      const family = await put(`/api/fuse/family/${data.id}`, d);

      toastr.success(`${data.name} updated!`, t('Success'));
      onSuccess(family);
    } catch (error) {
      toastr.error(error.message, t('Error while updating'));
    }
  };

  const getProperties = async () => {
    try {
      const propers = await get('/api/fuse/property?per=100');

      setProperties(propers.results);
    } catch (error) {
      await toastr.error(error.message, t('Error getting Fuse properties'));
    }
  };

  useEffect(() => {
    const origFields = [
      { name: 'manufacturer', label: 'Manufacturer', operators: ['contains', 'does not contain'] },
      { name: 'part_number', label: 'Part Number', operators: ['contains', 'does not contain'] },
    ];

    const dynamicFields = properties.map((x) => ({
      name: x.label,
      label: x.label,
      valueEditorType: 'select',
      values: (JSON.parse(x.choices) || []).map((c) => ({ name: c, label: c })) || [],
      operators: ['=', '!='],
    }));

    setFields([...origFields, ...dynamicFields]);
  }, [properties]);

  useEffect(() => {
    getProperties();
  }, []);

  const renderRuleEditor = (itm, index, remove, values, setFieldValue) => (
    <div className="mt-3 mb-3">
      <Row className="mt-3">
        <Col md="6">
          <Label
            for={`item_description_${itm.id}`}
          >
            {props.t('Description')}
          </Label>
          <Field
            className="form-control form-control-sm mb-3"
            name={`components[${index}].description`}
            placeholder={t('Describe type of component')}
          />
        </Col>

        <Col lg="4">
          <Label
            for={`item_scope_${itm.id}`}
          >
            {props.t('Scope')}
          </Label>
          <Field
            as="select"
            className="form-control form-control-sm mb-3"
            name={`components[${index}].scope`}
          >
            <option value="any">Any</option>
            <option value="listing">Listings Only</option>
            <option value="component">Components Only</option>
            <option value="instruction">Instruction Only</option>
          </Field>
        </Col>
      </Row>

      <Row key={index}>
        <Col md="12">
          {itm.item_id === null && itm.query === null && (
            <Button size="sm" color="link" type="button" className="border" onClick={() => { setComponentSelector(index); }}>
              {t('Select a component...')}
            </Button>
          )}
          {itm.item_id !== null && (
            <input className="form-control form-control-sm" readOnly value={`${itm.item.manufacturer} ${itm.item.part_number}`} />
          )}
          {itm.query !== null && (
            <QueryBuilder
              query={JSON.parse(values.components[index].query)}
              fields={fields}
              onQueryChange={(q) => {
                setFieldValue(`components[${index}].query`, JSON.stringify(q));
                // setFieldValue(`components[${index}].description`,
                // formatQuery(q, 'natural_language'));
              }}
            />
          )}
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md="9">
          <Label
            for={`item_instructions_${itm.id}`}
          >
            {props.t('Instructions')}
          </Label>
          <Field
            as="textarea"
            className="form-control form-control-sm"
            name={`components[${index}].instructions`}
          />
        </Col>

        <Col md="3">
          <Label
            for={`item_qty_${itm.id}`}
          >
            {props.t('Qty')}
          </Label>
          <InputGroup>
            <Field
              className="form-control form-control-sm"
              name={`components[${index}].item_qty`}
            />
            <Button
              type="button"
              color="danger"
              size="sm"
              onClick={() => remove(index)}
            >
              <span className="mdi mdi-close-thick" />
            </Button>
          </InputGroup>
        </Col>
      </Row>
    </div>
  );

  const jsx = (
    <Formik
      enableReinitialize
      initialValues={entity}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        if (!values.id) {
          createFamily(values);
        } else {
          editFamily(values);
        }
      }}
    >
      {({
        touched, errors, values, setFieldValue,
      }) => {
        const components = values.components || [];
        const scopedComponents = scopeTabs.map((scopeTab) => ({
          ...scopeTab,
          items: components
            .map((component, index) => ({ component, index }))
            .filter(({ component }) => (component.scope || 'any') === scopeTab.value),
        }));

        return (
          <Form id="FuseFamilyForm" autoComplete="off">
            <Row className="mt-3">
              <Col sm="6">
                <Label
                  for="name"
                >
                  {props.t('Family Name')}
                  {' '}
                  <sup className="text-danger">*</sup>
                </Label>
                <Field className="form-control" name="name" />
                <ErrorMessage
                  name="name"
                  component="div"
                  className="text-danger pt-2"
                />
              </Col>
            </Row>

            <h5 className="mt-4">{t('Required Component Stock')}</h5>

            <FieldArray name="components">
              {({ push, remove }) => (
                <div>
                  <Nav tabs className="mt-3">
                    {scopedComponents.map((scopeTab) => (
                      <NavItem key={scopeTab.value}>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={classnames({ active: activeScope === scopeTab.value })}
                          onClick={() => { setActiveScope(scopeTab.value); }}
                        >
                          {t(scopeTab.label)}
                          {' '}
                          <Badge
                            pill
                            color={activeScope === scopeTab.value ? 'primary' : 'light'}
                            className={classnames('ms-1', {
                              'text-white': activeScope === scopeTab.value,
                              'text-dark': activeScope !== scopeTab.value,
                            })}
                          >
                            {scopeTab.items.length}
                          </Badge>
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>

                  <TabContent activeTab={activeScope} className="border border-top-0 p-3">
                    {scopedComponents.map((scopeTab) => (
                      <TabPane tabId={scopeTab.value} key={scopeTab.value}>
                        <Card
                          className="border mb-3"
                          style={{
                            backgroundColor: 'rgba(255, 255, 255, 0.04)',
                            borderColor: 'rgba(255, 255, 255, 0.12)',
                          }}
                        >
                          <CardBody className="py-3">
                            <div className="fw-semibold mb-1">{t(scopeTab.description)}</div>
                            <div
                              className="mb-0"
                              style={{ color: 'inherit', opacity: 0.8 }}
                            >
                              {t(scopeTab.details)}
                            </div>
                          </CardBody>
                        </Card>
                        {scopeTab.items.length > 0 ? scopeTab.items.map((
                          { component: itm, index },
                          scopedIndex,
                        ) => (
                          <React.Fragment key={itm.id || `${scopeTab.value}-${index}`}>
                            {scopedIndex > 0 && (
                              <hr className="border-bottom m-4" />
                            )}
                            {scopeTab.value === 'instruction' ? (
                              <Card className="mt-3 border">
                                <button
                                  type="button"
                                  className="btn btn-link text-start text-decoration-none text-reset w-100 p-3"
                                  onClick={() => {
                                    setOpenInstructionRule(
                                      openInstructionRule === index ? null : index,
                                    );
                                  }}
                                >
                                  <div className="d-flex align-items-start justify-content-between gap-3">
                                    <div>
                                      <div className="fw-semibold">
                                        {itm.description || t('Untitled instruction rule')}
                                      </div>
                                      <div
                                        className="mt-1 fs-6"
                                        style={{ color: 'inherit', opacity: 0.8 }}
                                      >
                                        {itm.instructions || t('No instructions added')}
                                      </div>
                                    </div>
                                    <span className={classnames('mdi fs-5', {
                                      'mdi-chevron-up': openInstructionRule === index,
                                      'mdi-chevron-down': openInstructionRule !== index,
                                    })}
                                    />
                                  </div>
                                </button>
                                <Collapse isOpen={openInstructionRule === index}>
                                  <CardBody className="pt-0">
                                    {renderRuleEditor(itm, index, remove, values, setFieldValue)}
                                  </CardBody>
                                </Collapse>
                              </Card>
                            ) : (
                              renderRuleEditor(itm, index, remove, values, setFieldValue)
                            )}
                          </React.Fragment>
                        )) : (
                          <div className="text-muted">{t('No rules added for this scope')}</div>
                        )}
                      </TabPane>
                    ))}
                  </TabContent>

                  {componentSelector !== false && (
                    <div className="mt-3 mb-3">
                      <BaseGrid
                        url="/api/items"
                        hasSearch
                        shouldPaginate
                        config={
                        {
                          columns: {
                            part_number: {
                              label: 'PArt Number',
                              sort: true,
                            },
                            actions: {
                              label: props.t('Actions'),
                              actions: [
                                {
                                  key: 'select',
                                  icon: 'mdi mdi-check',
                                  class: 'btn btn-sm btn-soft-danger',
                                  alt: props.t('Select'),
                                  click: (itm) => {
                                    const existingComponent = values.components[componentSelector]
                                      || {};
                                    setFieldValue(`components[${componentSelector}]`, {
                                      ...existingComponent,
                                      item_id: itm.id,
                                      item: itm,
                                      item_qty: existingComponent.item_qty || 1,
                                      instructions: existingComponent.instructions || '',
                                      query: null,
                                      scope: existingComponent.scope || activeScope,
                                    });
                                    setComponentSelector(false);
                                  },
                                },
                              ],
                            },
                          },
                          pagination: {
                            sort: 'id',
                            direction: 'desc',
                            perPage: 3,
                          },
                        }
                        }
                      />
                    </div>
                  )}

                  <div className="hstack gap-2">
                    <Button
                      type="button"
                      color="primary"
                      className="mb-3 mt-3"
                      size="sm"
                      onClick={() => push({
                        item_id: null, item_qty: 1, instructions: '', query: null, scope: activeScope,
                      })}
                    >
                      <span className="mdi mdi-plus" />
                      {' '}
                      {t('Item')}
                    </Button>

                    <div>
                      {t('OR')}
                    </div>

                    <Button
                      type="button"
                      color="primary"
                      className="mb-3 mt-3"
                      size="sm"
                      onClick={() => push({
                        item_id: null, item_qty: 1, instructions: '', query: '{"combinator": "and","rules":[]}', scope: activeScope,
                      })}
                    >
                      <span className="mdi mdi-plus" />
                      {' '}
                      {t('Query')}
                    </Button>
                  </div>
                </div>
              )}
            </FieldArray>
          </Form>
        );
      }}
    </Formik>
  );

  return jsx;
}

FamilyForm.defaultProps = {
  entity: {
    name: '',
  },
  onSuccess: () => {},
};

FamilyForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(FamilyForm));
